const cabinetOrigin = process.env.VUE_APP_CABINET_ORIGIN.toUpperCase();

export default {
  //login home page
  loginHeader: {
    contactUs: '"تواصل معنا"',
  },
  loginPage: {
    instructionstitle: "لوحة التحكم",
    instructionsLine1:
    "رجاء الدخول على لوحة التحكم مستخدماً الايميل الخاص بك مع كلمة السر لحسابك مع شركة تريد فيو",
    instructionsLine2: "سوف تمكنك لوحة التحكم من الآت",
    featureList1: "معرفة الرصيد الخاص بحساباتك",
    featureList2: "الحصول على كشف الحساب",
    featureList3: "إيداع الأموال في حسابك",
    featureList4: "تحويل الأموال ما بين حساباتك المختلفة",
    featureList5: "تقديم طلب سحب الأموال",
    pFooter:"خدمات و منتجات شركة تريد فيو غير مقدمة للعملاء الأمريكان داخل الولايات المتحدة طبقا للقانون الأمريكي. المعلومات المقدمة هنا ليست مخصصة لمواطني أي دولة تضع قيود على تداول العملات والسلع والمعادن. جميع أدوات التداول  الخاصة بمنتجات عقود الفروقات السي اف دي هي منتجات معقدة و قد تحتوي على مخاطرة عالية و قد تتعرض للخسارة نتيجة استخدام الرافعة المالية. يجب عليك التأكد من إن كانت لديك القدرة على تحمل مثل هذه الخسارة" ,
    linkFooter: "link.",
    adressOficce: `Tradeview ${cabinetOrigin} Office:`,
    termsAndConditions: "الشروط و الأحكام",
    privacyPolicy: "سياسة الخصوصية",
    amlPolicy: "سياسة مكافحة غسيل الأموال",
    refundPolicy: "سياسة السحوبات",
    riskDisclosure: "تحذير المخاطر",
    complaintsProcedure: "إجراءات الشكوى",
    cookiePolicy: "سياسات الانترنت",
    userError:"اسم المستخدم أو كلمة المرور غير صحيحة",
    userErrorTwo: "المستخدم غير موجود",
    changeSuccess:"التغيير كان ناجحا!",
    passNotMatch:"كلمة المرور غير مطابقة.",
    passSpecialC:"يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل.",
    passNumber:"كلمة المرور يجب أن تحتوي على رقم واحد على الأقل.",
    passLength:"الطول أكبر من أو يساوي 6 أحرف، بما في ذلك الأرقام والأحرف الخاصة.",
    reviewData:"برجاء مراجعة البيانات المدخلة",
    valid:"الرجاء إدخال بريد إلكتروني/كلمة مرور صالحة"
  },
  loginBox: {
    logInGoogle: "ادخل عن طريق حسابك في جوجل",
    logInFacebook: "ادخل عن طريق حسابك في الفيس بوك",
    or: "او",
    email: "البريد الإلكتروني",
    password: "كلمة السر",
    submit: "الدخول",
    forgot: "هل نسيت كلمة المرور؟",
    doNotAccount: "ليس لديك حساب بعد؟",
    signUp: "سجل الآن",
    tryFreeDemo: "جرب في حساب تجريبي مجاني",
    liveAccountLink: "https://tradeviewmena.com/formIndividual/",
    demoAccountLink: "https://www.tradeviewmena.com/open-demo",
  },
  consoleHeader: {
    account: "رقم الحساب",
    balance: "الرصيد الإجمالي او البلانس",
    equity: "قيمه الحساب الفعلية أو الاكويتي",
    free: "الهامش الحر",
    margin: "نسبة الهامش",
    status: "الحالة",
    hello: "مرحبا",
    logout: "تسجيل الخروج",
    confirm: "تأكيد",
    outModal: "هل أنت متأكد من رغبتك في الخروج",
    yes: "نعم",
    not: "لا",
    selectlang: "اختر لغتك"
  },

  // Platforms page
  platforms: {
    title: "تحميل منصات التداول",
    accountLive: "خادم او سيرفر الحسابات الحقيقية",
    accountDemo: "خادم او سيرفر الحسابات التجريبية",
    tradeviewLive: "Tradeview-Live",
    tradeviewDemo: "Tradeview-Demo",
  },

  //History page
  history: {
    title: "تاريخ الحساب",
    accountActivity: "كشف الحساب",
    tradingHistory: "تاريخ التداول",
  },

  // Withdraw page
  withdraw: {
    title: "طلب السحب",
    platform: "المنصة",
    sourceAccount: "الحساب المحول منه*",
    method: "طريقة السحب*",
    currency: "العملة*",
    start: "اسحب الآن",
    beneficiary: "*اسم المستفيد",
    details:"المعلومات البنكية لحساب المستفيد",
    number: "*رقم الحساب او الاي بان إن وجد",
    code: "رقم السويفت كود",
    reference: "معلومات اضافية",
    subTitle: "معلومات البنك الوسيط إن وجد",
    name: "اسم البنك",
    bank: "عنوان البنك",
    swift: "رقم السويفت الخاص بالبنك",
    branch: "اسم الفرع",
    province: "المحافظة",
    city: "المدينة",
    dialogShow:
    "حدث خطأ! لا يوجد أي حسابات مفعلة على هذه المنصة و لا يمكنك الاستمرار. رجاء التأكد و إعادة المحاولة مع منصة اخرى",
    errorOne: "حدث خطأ! لا يمكنك ترك أي خانات فارغة",
    errorTwo: "حدث خطأ! قيمة السحب تفوق مبلغ الأموال الموجود في حسابك",
    errorThree: "حدث خطأ! الإيميل الخاص بك  غير صحيح",
    errorFour: "حدث خطأ! رجاء التأكد من صحة رقم بطاقة الأئتمان",
    dialogShowTwo: "تم استقبال طلبك و تم ارسال ايميل لك للتأكيد",
    dialogShowThree: "رجاء التواصل مع خدمة العملاء",
    tether: "العملات الرقمية",
    skrill: " سكريل",
    neteller: "نتلر",
    myfatoorah: "السحب بالفيزا",
    shift: "محفظة عملات رقمية",
    bank_wire: "عبر الحوالة البنكية",
    placeholAlternative1:"الايميل المسجل في حساب سكريل الخاص بك",
    placeholAlternative2:"رقم حساب",
    placeholAlternative3:"الايميل",
    placeholAlternative4:"اخر 4 ارقام من بطاقة الائتمان",
    placeholAlternative5:"رقم المحفظة الرقمية",
    ok: "تمام"
  },

  //Account Activity page
  accountActivity: {
    title: "كشف الحساب",
    from: "*من",
    to: "*إلى",
    type: "*نوع الحساب",
    platform: "*المنصة",
    placeholderAccount: "حساب التداول",
    account: "*الحساب",
    get: "احصل",
    row: "عدد المعاملات في الصفحة",
    download: "حمل التقرير",
    back: " السابق ",
    confirm: "تأكيد",
    close: "إغلاق",
    error: "حدث خطأ! لا يمكنك ترك أي خانات فارغة",
    errorTwo: "حدث خطأ! يجب ان تختار احد الخيارات المتاحة",
    activityid: "رقم المعاملة",
    platfomr: "المنصة",
    date: "التاريخ و الوقت",
    activity: "المعاملة",
    profit: "الربح و الخسارة",
    nohistory: 'الحساب ليس له تاريخ بعد'
  },

  //tradingHistory
  tradingHistory: {
    title: "كشف الحساب",
    from: "*من",
    to: "*إلى",
    type: "*نوع",
    platform: "*المنصة",
    placeholderAccount: "رقم الحساب",
    account: "*الحساب",
    get: "احصل",
    row: "عدد الصفقات في الصفحة",
    download: "حمل التقرير",
    back: " السابق ",
    confirm: "تأكيد",
    close: "إغلاق",
    error: "حدث خطأ! لا يمكنك ترك أي خانات فارغة",
    errorTwo: "حدث خطأ! يجب ان تختار احد الخيارات المتاحة",
    deal: "رقم الصفقة",
    entryTime: "وقت الدخول",
    typr: "النوع",
    simbol: "الرمز",
    volume: "الحجم",
    entryPrice: "سعر الدخول",
    sl: "وقف الخسارة",
    tp: "جني الربح",
    exitTime: "وقت الخروج",
    exitPrice: "سعر الخروج",
    commision: "الكوميشن",
    swap: "السواب",
    profit: "الربح و الخسارة",
  },

  newLiveAccount: {
    title: "قم بإنشاء حساب جديد",
    platform: "*اختار المنصة",
    currency: "العملة",
    account: "إنشاء حساب",
    back: " السابق ",
    congratulation: "مبروك!",
    text: "تم استقبال طلبك بفتح حساب جديد و جاري أجراء الازم من طرف قسم فتح الحسابات الجديده. سوف يتم التواصل معك ان كان هناك معلومات أضافيه مطلوبه منك",
    error: "حدث خطأ! لا يمكنك ترك أي خانات فارغة",
    close: "إغلاق",
  },

  //Transfer page
  transfer: {
    title: "التحويل من بين حسابات التداول",
    subTitle:
    "رجاء إكمال البيانات التالية حتى نتكمن من تحويل الأموال بين حساباتك",
    platform: " المنصة",
    sourceAcount: "الحساب المراد التحويل منه",
    targetAccount: "الحساب المراد التحويل إليه",
    sendingAmount: "المبلغ المطلوب تحويله",
    condition:
    "رجاء القيام بالضغط على الزر حتى يتم تحويل الأموال. بالضغط على هذا الزر فأنت تقر بقيامك بطلب تحويل الأموال ما بين حساباتك مع شركه تريد فيو",
    condition2:
    "رجاء القيام بالضغط على الزر حتى يتم تحويل الأموال. بالضغط على هذا الزر فأنت تقر بقيامك بطلب تحويل الأموال ما بين حساباتك مع شركه تريد فيو",
    start: "قم بالتحويل",
    showDialogOne: "رجاء التواصل مع خدمة العملاء",
    showDialogTwo: "رجاء التواصل مع خدمة العملاء",
    submited: "تم استقبال طلبك. و تم ارسال إيميل لك للتأكيد",
    success: "تم التحويل الداخلي بنجاح",
    error: "حدث خطأ! لا يمكنك ترك أي خانات فارغة",
    erroremail: "حدث خطأ! الإيميل الخاص بك غير صحيح",
    errorcheck: "يجب عليك الموافقة على سياسات تريد فيو",
    errorTwo: "حدث خطأ! أرقام الحسابات يجب ان تكون مختلفة",
    errorThree: "حدث خطأ! المبلغ به خطأ",
    errorFour: "حدث خطأ! قيمه التحويل تفوق المبلغ الموجود في حسابك",
  },

  //Accounts
  accounts: {
    warning: "تم إستقبال طلب فتح حساب تجريبي. سوف يتم إرسال ايميل لك بالتفاصيل",
    live: "حسابات التداول الحقيقية",
    demo: "الحسابات التجريبية",
    createLive: "+افتح حساب حقيقي جديد",
    createDemo: "+افتح حساب تجريبي جديد",
    noAccountLive: "لا يوجد حساب حقيقي تحت هذا الايميل",
    noAccountDemo: "لايوجد حساب تجريبي تحت هذا الايميل",
    dialogShowOne:
      "لا يوجد لديك اي حسابات تجريبية على منصة الميتاتريدر 4 حالياً ",
    dialogShowTwo:
      "لا يوجد لديك اي حسابات تجريبية على منصة الميتاتريدر 5 حالياً ",
    dialogShowThree:
      "لا يوجد لديك اي حسابات حقيقية على منصة الميتاتريدر 4 حالياً ",
    dialogShowFour:
      "لا يوجد لديك اي حسابات حقيقية على منصة الميتاتريدر 5 حالياً ",
    dialogShowFive: "لا يوجد لديك أي حسابات حقيقيه على منصات الميتاريدر 4 او 5",
    account: "ارقام الحسابات",
    balance: "الرصيد الإجمالي او البلانس",
    equity: "قيمة الحساب الفعلية أو الاكويتي",
    margin: "مستوى الهامش",
    free: "الهامش الحر",
    status: "الحالة",
    leverage: "الرافعة",
    currency: "العملة",
  },

  //CreateDemoAccounts
  demoAccounts: {
    title: "طلب فتح حساب تجريبي",
    platform: "*اختار المنصة",
    type: "*نوع الحساب",
    amount: "*حجم الإيداع",
    currency: "العملة",
    account: "إنشاء حساب الجديد",
    back: "السابق",
    created: "تم إنشاء حساب تجريبي جديد لك",
    text: "رجاء ان تقوم بالاحتفاظ بمعلومات الحساب قبل غلق هذه الشاشة. لن يتم ارسال ايميل لك بمعلومات الحساب",
    login: "تسجيل الدخول",
    pass: "كلمة السر",
    currencyTwo: "العملة",
    server: "الخادم",
    data: "Tradeview-Demo",
    download: "يمكنك الآن تحميل منصة التداول",
    close: "إغلاق",
    error: "حدث خطأ! لا يمكنك ترك أي خانات فارغة",
    ilc: "اسبرد اي سي ان - ILC",
    xleverage: "الاسبرد الكلاسيكي - xLeverage",
    createDemoAccountError: "حدث خطأ. رجاء التواصل مع الدعم لتقديم المساعدة لك",
    createDemoAccountSucces: "تم ارسال طلبك"
  },

  //credit card
  credit: {
    title: "الإيداع عبر بطاقة الائتمان",
    subTitle: "هذا القسم غير متاح في الوقت الحالي",
    subTitleAdd: "أودع الأموال",
    platform: "المنصة",
    trading: "رقم الحساب",
    amount:
      "أقل مبلغ للإيداع هو 10 دولار امريكي و اقصى مبلغ هو 10 آلاف دولار في المرة الواحدة*",
    currency: "العملة",
    details: "رقم البطاقة",
    expiration: "تاريخ الانتهاء",
    fund: "المبلغ",
    disclaimer:
      "صاحب الحساب هو المحق له القيام بالإيداع في الحساب  فقط. قد يتم طلب بعض المعلومات الإضافية منك للتأكد من صحة البيانات التي استخدمتها",
    back: "السابق",
    confirm: "تأكيد",
    textOne: "هل أنت متأكد من إتمام عملية الإيداع",
    textTwo: "ببطاقة الائتمان الخاصه بك؟",
    cancel: "إلغاء",
    deposit: "أودع",
    ok: "نفذ",
    depositUrl: "سوف تذهب لموقع شركة الفيزة",
    errorOne: "حدث خطأ ! المبلغ المراد دفعه غير صحيح",
    errorTwo: "حدث خطأ! لا يمكنك ترك أي خانات فارغة",
    errorThree: "حدث خطأ! رمز التحقق للبطاقة/كود الامان غير صحيح",
    errorFour: "حدث خطأ! تاريخ انتهاء البطاقه غير صحيح",
    errorFive: "حدث خطأ!  رقم البطاقة غير صحيح",
  },

  //Banck Transfer add found Skrill
  addFounds: {
    firstname: "اسمك الأول",
    lastname: "إسمك الأخير",
    title: "أودع الأموال",
    platform: "المنصة",
    account: "رقم الحساب",
    currency: "العملة",
    range: "المدى",
    amount: "المبلغ",
    disclaimer:
      "صاحب الحساب هو المحق له القيام بالإيداع في الحساب  فقط. قد يتم طلب بعض المعلومات الإضافية منك للتأكد من صحة البيانات التي أستخدمتها",
    fund: "أودع",
    back: "السابق",
    redi: "إعادة توجيه",
    redirection: "إعادة توجيه إلى",
    checkmark: "بالضغط على هذا الزر فأنت توافق على كل سياسات شركة تريد فيو",
    submit: "سلم",
    fundCreditCard: "ادفع عبر بطاقات الائتمان",
    btnApplePay: "ادفع عبر الابل باي",
    dob: "تاريخ الميلاد",
    alertTitle: "هام:",
    alertDesc: " أنت كنت مواطن أحد الدول التالية (اليمن والصومال ولبنان وسوريا) فرجاء أن ترسل أي تحويلات كربتو الي المحفظة التأليه تجنبا لأي تأخير في الإيداع",
    alertNote:"رجاء ان ترسل الهاش الخاص بالإيداع مع رقم حسابك الي البريد التالي حتي نتمكن من ايداعه في حسابك"
  },

  //Add Bank Funds
  addBanckFounds: {
    title: "أودع المال",
    description: "رجاء استخدام هذه المعلومات للتحويلات البنكية",
    back: "السابق",
    headers1: "للإيداعات بالدولار الأمريكي",
    rows1Headers1: "اسم البنك",
    subrows1Headers1: "BMO Harris Bank, N.A",
    rows2Headers1: "رقم السويف كود",
    subrows2Headers1: "HATRUS44",
    rows3Headers1: "رقم ABA",
    subrows3Headers1: "071000288",
    rows4Headers1: "معلومات إضافية",
    subrows4Headers1: "أسمك الكامل مع رقم حسابك في تريد فيو",
    rows5Headers1: "اسم الحساب المستفيد:",
    subrows5Headers1: `Tradeview ${cabinetOrigin} Limited`,
    rows6Headers1: "رقم الحساب:",
    subrows6Headers1: "4243275",
    rows7Headers1: "عنوان البنك",
    subrows7Headers1: "111 West Monroe St, Chicago, IL 60690",
    rows8Headers1: "عنوان المستفيد:",
    subrows8Headers1: "114/3 The Strand, Gzira, GZR 1027, Malta",
    headers2: "للإيداعات بالدولار الأمريكي",
    rows1Header2: "Beneficiary Bank",
    subrows1Header2: "BMO Harris Bank, N.A",
    rows2Header2: "رقم السويف كود",
    subrows2Header2: "HATRUS44GTM",
    rows3Header2: "البنك الوسيط",
    subrows3Header2: "Deutsche Bank - Frankfurt",
    rows4Header2: "رقم السويفت كود للبنك الوسيط",
    subrows4Header2: "DEUTDEFF",
    rows5Header2: "معلومات إضافية",
    subrows5Header2: "أسمك الكامل مع رقم حسابك في تريد فيو",
    rows6Header2: "اسم حساب المستفيد",
    subrows6Header2: `Tradeview ${cabinetOrigin} Limited`,
    rows7Header2: "رقم الحساب",
    subrows7Header2: "300894250262",
    rows8Header2: "عنوان البنك",
    subrows8Header2: "111 West Monroe St, Chicago, IL 60603",
    rows9Header2: "عنوان المستفيد",
    subrows9Header2: "114/3 The Strand, Gzira, GZR 1027, Malta",
    headersSecond: "للإيداعات بالاسترليني و اليورو و الدولار و السويسري و الين",
    rows1HeadersSecond: "اسم بنك المستفيد",
    subrows1HeadersSecond: "The Currency Cloud Limited",
    rows2HeadersSecond: "رقم السويفت الخاص بحساب المستفيد",
    subrows2HeadersSecond: "TCCLGB3L",
    rows3HeadersSecond: "رقم الأي بان",
    subrows3HeadersSecond: "GB62TCCL04140476597833",
    rows4HeadersSecond: "معلومات إضافية",
    subrows4HeadersSecond:
      "ادخل الرقم التالي 21040856275 مع أسمك مع رقم حسابك مع تريد فيو",
    rows5HeadersSecond: "اسم الحساب المستفيد",
    subrows5HeadersSecond: `Tradeview ${cabinetOrigin} Limited`,
    rows6HeadersSecond: "رقم الحساب",
    subrows6HeadersSecond: "4243275",
    rows7HeadersSecond: "عنوان البنك",
    subrows7HeadersSecond:
      "12 Steward Street, The Steward Building, London, E1 6FQ",
    rows8HeadersSecond: "عنوان المستفيد:",
    subrows8HeadersSecond: "114/3 The Strand, Gzira, GZR 1027, Malta",
    headersSecond2: "للإيداعات بعملة اليورو",
    rows1HeadersSecond2: "اسم حساب المستفيد",
    subrows1HeadersSecond2: "Tradeview Europe Ltd Clients Fund Account",
    rows2HeadersSecond2: "العملة:",
    subrows2HeadersSecond2: "اليورو",
    rows3HeadersSecond2: "رقم الايبان",
    subrows3HeadersSecond2: "MT95PYMX09014000002061220100001",
    rows4HeadersSecond2: "BIC:",
    subrows4HeadersSecond2: "PYMXMTMT",
    rows5HeadersSecond2: "معلومات إضافية",
    subrows5HeadersSecond2:
      "اسمك الكامل بالاضافه الي رقم حسابك مع شركه تريد فيو",
    rows6HeadersSecond2: "اسم البنك",
    subrows6HeadersSecond2: "The Currency Cloud Limited",
    rows7HeadersSecond2: "عنوان البنك",
    subrows7HeadersSecond2:
      "12 Steward Street, The Steward Building, London, E1 6FQ",
    rows8HeadersSecond2: "عنوان المستفيد",
    subrows8HeadersSecond2: "114/3 The Strand, Gzira, GZR 1027, Malta",
  },

  //Banregio
  banregio: {
    deposit: "الإيداع بالبيسو المكسيكي",
    accountName: "اسم حساب المستفيد",
    bankaddres: "عنوان البنك",
    phone: "رقم الهاتف",
    pesos: "رقم حساب البنك بالبيسو",
    swift: "رقم السويف كود",
    clabe: "CLABE:",
    accountNameinfo: "TVM capital S.A de C.V",
    bankaddresinfo:
      "Av. Insurgentes Sur #4250, Col. Colinas de San Jerónimo, Monterrey, Nuevo León",
    phoneinfo: "(81) 21-42-64-30",
    pesosinfo: "035-93009-001-6",
    swiftinfo: "RGIOMXMTXXX",
    clabeinfo: "058580359300900162",
  },

  //fidelity
  fidelity: {
    deposit1: "Deposit USD / FIELD 56- INTERMEDIARY BANK",
    deposit2:
      "Deposit USD / FIELD 57- BENEFICIARY BANK - ACCOUNT WITH INSTITUTION",
    deposit3: "Deposit USD / FIELD 59 - BENEFICIARY CUSTOMER",
    bankname: "اسم البنك",
    bankaddres: "عنوان البنك",
    swift: "رقم السويفت",
    routing: "رقم الرواتينج",
    banknameinfo: "Deutsche Bank Trust Company Americas",
    bankaddresinfo: "Jersey City, New Jersey",
    swiftinfo: "BKTRUS33XXX",
    routinginfo: "021-001-033",
    accountname: "اسم الحساب المستفيد:",
    address: "العنوان",
    swiftbic: "رقم السويفت",
    accountnameinfo: "Proven Bank (Cayman) Limited",
    addressinfo: "36A Dr. Roy’s Drive, GT, Grand Cayman, Cayman Islands",
    swiftbicinfo: "FIYCKYKYXXX",
    accountnumber: "رقم الحساب",
    name: "الإسم",
    accountnumberinfo: "2020-4178",
    nameinfo: "Tradeview Ltd",
    addressinfo2:
      "103 S. Church St, 4th Fl, Grand Cayman, Cayman Islands, KY1-1002",
  },

  //Bbva
  bbva: {
    deposit: "الإيداع بالدولار الأمريكي",
    beneficiary: "اسم حساب المستفيد",
    ruc: "RUC:",
    beneficiarybank: "أسم بنك المستفيد",
    bankaddres: "عنوان البنك",
    swift: "رقم السويفت كود",
    accountn: "رقم الحساب",
    cci: "CCI:",
    beneficiaryinfo: "TV MARKETS SAC",
    rucinfo: "20605189394",
    beneficiarybankinfo: "BBVA",
    bankaddresinfo: "Avenida Republica de Panama 3055, San Isidro. Lima - PERU",
    swiftinfo: "BCONPEPL",
    accountninfo: "0011-0351-0100035781",
    cciinfo: "011-351-000100035781-42",
  },
  //DBS
  dbs: {
    deposit: "الإيداع بالدولار الأمريكي",
    beneficiary: "إسم المستفيد",
    beneficiaryAccountNumber: "رقم حساب بنك المستفيد",
    beneficiaryaddres: "عنوان بنك المستفيد",
    swift: "رقم السويفت",
    bankname: "اسم البنك",
    bankaddres: "عنوان البنك",
    beneficiaryinfo: "WTSG Tradeview Ltd",
    beneficiaryAccountNumberinfo: "072-036473-2",
    beneficiaryaddresinfo: "#12-01 Capital Tower, 168 Robinson Road, Singapore, 068912",
    swiftinfo: "DBSSSGSG",
    banknameifo: "DBS Bank",
    bankaddresinfo:
      "12 Marina Boulevard, DBS Asia Central, Marina Bay Financial Centre Tower 3, Singapore 018982",
  },

  //Choose bank
  chooseBank: {
    title: "اختار البنك",
    method: "طريقة الإيداع",
    processing: "الوقت الذي تستغرقه عملية الإيداع",
    fee: "الرسوم",
    back: "السابق",
    instruction:
      '"تنويه!شركة تريد فيو لا تقبل الإيداعات من طرف ثالث. كل الإيداعات يجب أن تأتي من حساب العميل صاحب الحساب. حسابات التداول كلها بعملة الدولار الأمريكي. شركة تريد فيو تحتفظ بحقها في رفض او الغاء أي إيداع تم ببطاقة الائتمان و إرجاعه لنفس البطاقة". التداول يحتمل الربح و الخسارة و قد تكون الخسارة اكبر من المبلغ المستثمر"',
    localdeposits:"شركه تريد فيو تقدم بعض خدمات الإيداع المحلي لبعض عملائها في الشرق الأوسط. إن كانت لديك الرغبة في الأستفادة من هذه الخدمة فرجاء توفير المعلومات التالية و سوف نتواصل معك إن كان بمقدرونا تزويدك بها في بلدك.",
    accountnumber:"رقم حساب التداول الخاص بك مع تريد فيو",
    amount:"المبلغ المراد إيداعه",
    submit:"سلم",
    sendmessage: "تم استقبال طلبك بنجاح . سوف يتواصل معك فريق الدعم العربي في اسرع وقت . مع الشكر"
  },

  //Choose Credit Card
  ChooseCreditCard: {
    title: "أختار بطاقة الائتمان",
    method: "طريقة الإيداع",
    processing: "الوقت الذي تستغرقه عملية الإيداع",
    fee: "الرسوم",
    back: "السابق",
    messageZotapay: "طريقه الإيداع هذه غير متاحه الآن",
    instructionOne:
      "شركة تريد فيو تحرص دائما على تحسين الخدمات التي تقدمها للعملاء. لهذا السبب فنحن نقدم لعملائنا أسرع طرق الإيداع المتاحة. لو كانت لديك الرغبة فرجاء",
    contact: "التواصل",
    instructionTwo: "مع فريق الدعم و سوف نقوم بالتواصل معك في اسرع وقت ممكن",
    instructionThree:
      "شركة تريد فيو لا تقبل الإيداعات من طرف ثالث. كل الإيداعات يجب أن تتم من صاحب الحساب فقط. حسابات التداول إما بالدولار او باليورو. تريد فيو تحتفظ بحقها في رفض أو ارجاع أي إيداع تم ببطاقة الأئتمان بصورة غير صحيحة",
  },

  //Choose alternative methods
  ChooseAlternativeMethods: {
    title: "طرق إيداع بديلة",
    method: "طريقة الإيداع",
    processing: "الوقت الذي تستغرقه عملية الإيداع",
    fee: "الرسوم",
    back: "السابق",
    instructionOne:
      '"تنويه!شركة تريد فيو لا تقبل الإيداعات من طرف ثالث. كل الإيداعات يجب أن تأتي من حساب العميل صاحب الحساب. حسابات التداول كلها بعملة الدولار الأمريكي. شركة تريد فيو تحتفظ بحقها في رفض او الغاء أي إيداع تم ببطاقة الائتمان و إرجاعه لنفس البطاقة". التداول يحتمل الربح و الخسارة و قد تكون الخسارة اكبر من المبلغ المستثمر".',
  },

  //deposit
  deposit: {
    title: "إختار طريقة الإيداع",
    vendor: "طريقة الإيداع",
    processingCards: "الوقت الذي تستغرقه عملية الإيداع",
    fee: "الرسوم",
    methodOne: "بطاقات الائتمان و  آبل باي",
    methodOneMena: "بطاقات الائتمان و  آبل باي",
    methodTwo: "طرق بديلة",
    methodThree: "التحويل البنكي",
    methodFour:"العملات الرقمية",
    textOne:
      "شركة تريد فيو تحرص دائما على تحسين الخدمات التي تقدمها للعملاء. لهذا السبب فنحن نقدم لعملائنا أسرع طرق الإيداع المتاحة. لو كانت لديك الرغبة فرجاء",
    textTwo: "التواصل",
    textThree: "مع فريق الدعم و سوف نقوم بالتواصل معك في اسرع وقت ممكن",
    textFour:
      "شركة تريد فيو لا تقبل الإيداعات من طرف ثالث. كل الايداعات يجب أن تتم من صاحب الحساب فقط. حسابات التداول إما بالدولار او اباليورو. تريد فيو تحتفظ بحقها في رفض أو ارجاع أي إيداع تم ببطاقة الأئتمان بصورة غير صحيحة",
    textOneMena:
      "Tradeview Financial Markets SAC شركة تريد فيو تحرص دائما على تحسين الخدمات التي تقدمها للعملاء. لهذا السبب فنحن نقدم لعملائنا أسرع طرق الإيداع المتاحة. لو كانت لديك الرغبة فرجاء ",
    textTwoMena: "التواصل",
    textFourMena:
      "شركة تريد فيو لا تقبل الإيداعات من طرف ثالث. كل الايداعات يجب أن تتم من صاحب الحساب فقط. حسابات التداول إما بالدولار او اباليورو. تريد فيو تحتفظ بحقها في رفض أو ارجاع أي إيداع تم ببطاقة الأئتمان بصورة غير صحيحة",
  },

  //Email
  email: {
    title: "إعدادات البريد الإكتروني",
    subTitle:
      "يمكنك هنا ان تدير كل الاشتراكات البريدية و انت تختار المواضيع المهمة التي تود التعرف عليها من خلال رسائلنا",
    company: "اخبار الشركة",
    selectOne: "اخبار التداول",
    selectTwo: "Surf's Up!",
    selectThree: "الأخبار الجديدة",
    update: "تحديث",
    instructions:
      "إن لم تكن لديك الرغبة في أن تسقبل أي إيميلات حول المواضيع السابقة فيمكنكم ازالة الخيارات و تضغط على تحديث",
    confirm: "تأكيد",
    submitted: "تم استقبال طلبك",
    close: "إغلاق",
  },

  //password
  password: {
    title: "قم بتغيير كلمة السر",
    subTitle:
      "للقيام بتغيير كلمة السر فسوف يتم ارسال كود خاص الى بريدك الالكتروني المسجل معنا",
    request: "اطلب الحصول علي الكود الآن",
    submit: "سلم طلبك",
    code: "الكود",
    current: "كلمة السر الحالية",
    confirm: "تأكيد",
    repeat: "كرر كلمه السر",
    save: "إحفظ التغييرات",
    success: "تمت بنجاح",
    close: "إغلاق",
    dialogMessage: "تم ارسال كود يستخدم لمرة واحدة الى بريدك المسجل لدينا",
    dialogMessageOne: "رجاء كتابة كلمة السر الحالية",
    dialogMessageTwo: "رجاء كتابة كلمة السر الجديدة",
    dialogMessageThree: "رجاء تأكيد كلمة السر الجديدة",
    dialogMessageFour: "كلمة السر الجديدة و الـتأكيد غير متطابقان",
  },

  //Contact
  contact: {
    title: "أطلب التواصل عبر الهاتف",
    firstname: "اسمك الأول",
    lastname: "إسمك الأخير",
    phone: "رقم الهاتف الخاص بك",
    email: "بريدك الإلكتروني",
    lenguage: "اختار اللغة التي تود التواصل بها مع الدعم",
    call: "الوقت الذي تفضله للتواصل",
    check: "تواصلوا معي في اسرع وقت ممكن",
    contactme: "تواصلوا معي",
    error: "حدث خطأ! لا يمكنك ترك أي خانات فارغة",
    close: "إغلاق",
    request: "طلب مقدم! تفقد بريدك الالكتروني من فضلك",
  },

  menu: {
    appli: "طلبات فتح حساب",
    account: "الحسابات",
    platforms: "منصات التداول",
    history: "سجل الحسابات",
    deposit: "الإيداع",
    transfer: "تحويل الأموال",
    withdraw: "طلب السحب",
    settings: "إعدادات",
    passwordsettings: "إعدادات كلمة السر",
    emailsettings: "إعدادات البريد الألكتروني",
    authenticationsettings: "إعدادات التأكيد",
    contactUs: "تواصل معنا",
  },

  //register
  register: {
    title: "تسجيل للدخول الى لوحة التحكم",
    create: "إنشاء معلومات الدخول",
    createdes: "إبدأ بإدخال إيميلك و كلمة السر الخاصة بك",
    complete: "أكمل طلب فتح الحساب",
    completedes: "قم بإكمال استمارة فتح الحساب",
    confirm: "أكد شخصيتك",
    confirmdes:
      "يمكنك تأكيد شخصيتك عبر الانترنت أو يمكنك تحميل هويتك لو تطلب الأمر",
    fund: "إدعم حسابك و تداول",
    funddes:
      "بعد الموافقة على حسابك. يمكنك دعم حسابك باستخدام أحد وسائل الدفع السهلة و المتاحة لك حتى تبدأ التداول",
    goBack: "السابق",
    getYour: "للدخول على لوحة التحكم, ما عليك الا تعبأة البيانات ادناه",
    instantly: "سجل لحظيا",
    registerGoogle: "سجل عن طريق جوجل",
    registerFacebook: "سجل عن طريق الفيس بوك",
    or: "او",
    email: "*البريد الإلكتروني",
    secure: "*كلمة السر الآمنة للعميل",
    length:
      "كلمة السر يجب ان تتكون من ستة حروف أو أكثر و تتضمن ارقام و رموز خاصة من التالي  !@#$%^&* ",
    confirmPassword: "*أكد على كلمه السر",
    disclaimer: "تنويه:",
    disclaimerdes1: "قبل فتح الحساب نود أن ننوهكم بالتالي",
    disclaimerdes2:
      " غير مقدمة للعملاء الأمريكان داخل الولايات المتحدة طبقا للقانون الأمريكي. المعلومات المقدمة هنا ليست مخصصة لمواطني أي دولة تضع قيود على تداول العملات والسلع والمعادن. جميع أدوات التداول  الخاصة بمنتجات عقود الفروقات السي اف دي هي منتجات معقدة و قد تحتوي على مخاطرة عالية و قد تتعرض للخسارة نتيجة استخدام الرافعة المالية. لهذا يجب عليك ان تتعرف على آليات التداول في هذه المنتجات.  يمكنك التعرف على المزيد من خلال الرابط التالي",
    clientAgree: "اتفاقية العملاء",
    byTicking: "بالضغط علي هذا الزر فأنت توافق على المذكور أعلاه",
    wish: "*أود ان أكون من أوائل الذين يعلمون عن المنتجات الجديدة و أخبار الشركة و التداول و العروض الخاصة",
    policity: "سياسية الخصوصية",
    getstarted: "ادخل الى لوحة التحكم",
    messageFooter1: "الخدمات و المنتجات المقدمه من",
    messageFooter2:
      " غير مقدمة للعملاء الأمريكان داخل الولايات المتحدة طبقا للقانون الأمريكي. المعلومات المقدمة هنا ليست مخصصة لمواطني أي دولة تضع قيود على تداول العملات والسلع والمعادن. جميع أدوات التداول  الخاصة بمنتجات عقود الفروقات السي اف دي هي منتجات معقدة و قد تحتوي على مخاطرة عالية و قد تتعرض للخسارة نتيجة استخدام الرافعة المالية. لهذا يجب عليك ان تتعرف على آليات التداول في هذه المنتجات.  يمكنك التعرف على المزيد من خلال الرابط التالي",
    youcan: "يمكنك استخدام",
    freeDemo: "حسابك المجاني التجريبي",
    desYouCan:
      "مع كل  منصات التداول متضمنا اجهزة سطح المكتب او اجهزة الهاتف المحمول من الاي فون او الاندرويد",
    client: "لوحة التحكم",
    desYouCan2: "لوحة التحكم الخاصة بحساباتك",
    practice: "تداول",
    practicedes: "تداول بأموال افتراضية في حساب تجريبي",
    learn: "تعرف على المنصة و أدواتها المختلفة و خدماتنا",
    learndes: "تعرف علي خصائص المنصة و التداول",
    titleTwo: "للدخول على لوحة التحكم, ما عليك الا تعبأة البيانات ادناه",
    titleTwob: "قدم بعض المعلومات الأساسية",
    name: "*الاسم الأول",
    lastName: "*الأسم الأخير",
    register: "ادخل الى لوحة التحكم",
    errorOne: "يرجى تعبئة جميع الحقول المطلوبة.",
    errorTwo: "كلمة المرور غير مطابقة.",
    errorThree: "يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل.",
    errorFour: "كلمة المرور يجب أن تحتوي على رقم واحد على الأقل.",
    errorFive: "الطول أكبر من أو يساوي 6 أحرف، بما في ذلك الأرقام والأحرف الخاصة.",
    errorSix: "الرجاء إدخال بريد إلكتروني وكلمة مرور صالحين.",
    errorSeven: "حقول مفقودة",
    errorEight:"خطأ: غير قادر على تحديث سجل التطبيق",
    login: "تسجيل الدخول",
    ok:"تمام",
    chenge: "يتغير",
    yes:"نعم",
    sendCode:"إرسال كود تفعيل أخر",
    submit: "سلم",
    accountRe: "تسجيل الحساب |",
    description: "قم بتسجيل حسابك، أنت على بعد 4 خطوات فقط من إنشاء حساب جديد",
    codeDialog: "الرجاء إدخال رمز التفعيل الذي تم إرساله إلى بريدك الإلكتروني.",
    codeDialogTwo: "تأكد من التحقق من مجلدات الرسائل غير المرغوب فيها/البريد العشوائي.",
    newCode: "تم إرسال رمز جديد إلى بريدك الإلكتروني. الرجاء إدخال رمز التفعيل.",
    tryEgain: "الرجاء معاودة المحاولة في وقت لاحق",
    registering:"نجاح! يرجى مواصلة التسجيل",
    instructions:"تحقق من بريدك الإلكتروني للحصول على الإرشادات",
    mfaCode:"أدخل رمز وزارة الخارجية:",
    code:"شفرة",
    newPass:"كلمة المرور الجديدة",
    repeatPass:"اعد كلمة السر",
    changePass:"تغيير كلمة المرور"
  },

  //Calendar
  calendar: {
    title: "النتيجة ",
  },
  //application process
  application: {
    pending:
    "تم استقبال طلب فتح الحساب الخاص بك و جاري العمل عليه الآن و سوف نوافيك بالتحديثات عبر الايميل",
    active: "لديك حساب تداول بالفعل",
    details: "عملية فتح الحساب",
    reject: "لم نتمكن من فتح حسابك. رجاء التواصل مع الدعم",
    tradeviewmena: "لم يتم تفعيل نموذج الطلب لهذا البلد بعد",
  },
  //MFA
  mfa: {
    title: "إعدادات المصادقة الثنائية",
    subTitle: "هذا القسم غير متاح في الوقت الحالي",
    enable: "تفعيل مصادقة الدخول الثنائية",
    body: "بالإضافة إلى كلمة المرور الخاصة بك، يمكنك إعداد مصادقة الدخول الثنائية لإعطاء حسابك طبقة اضافية من الامان.",
    text: "عند تفعيل مصادقة الدخول الثنائية، سوف نطلب منك إدخال كلمة المرور الخاصة بك بالإضافة إلى رمز التحقق الذي سوف يتم إرساله إلى عنوان بريدك الإلكتروني.",
    turn: "قم ",
    on: "بالتفعيل",
    off: "بعدم التفعيل",
    confirm: "تأكيد",
    textTwo: "هل انت متأكد انك لا تود تفعيل خاصية مصادقة الدخول الثنائية؟",
    yes: "نعم",
    no: "لا",
    qr: "يرجى مسح رمز الاستجابة السريعة (QR) باستخدام تطبيق الكاميرا  من خلال هاتفك ",
    type: "اكتب الكود الذي تم إنشاؤه:",
  },
};
